import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { DialogApprovalsEquipmentsApproveModule } from './../dialog-approvals-approve/dialog-approvals-approve.module';
import { DialogApprovalsEquipmentsRejectModule } from './../dialog-approvals-reject/dialog-approvals-reject.module';
import { DialogApprovalsEquipmentsDiffComponent } from './dialog-approvals-equipments.component';

@NgModule({
  entryComponents: [
    DialogApprovalsEquipmentsDiffComponent
  ],
  declarations: [
    DialogApprovalsEquipmentsDiffComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,

    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatTooltipModule,
    DialogApprovalsEquipmentsApproveModule,
    DialogApprovalsEquipmentsRejectModule,
    DisclaimerModule
  ],
  exports: [
    DialogApprovalsEquipmentsDiffComponent
  ]
})
export class DialogApprovalsEquipmentsDiffModule { }
